import { useRef } from 'react';

const useDirty = <T>(value: T): boolean => {
  // capture a JSON snapshot on first render
  const originalRef = useRef<string>(JSON.stringify(value));
  // compare current snapshot to original
  return JSON.stringify(value) !== originalRef.current;
};

export default useDirty;
